module.exports = __webpack_public_path__ + "img/weather_moon.7c7fdeb7.png";